<template>
  <div>
    <Head />
    <div class="wrap">
      <div class="cont">
        <div>
          <h1>Зуботехническая цифровая лаборатория</h1>
          <p>
            С помощью компьютерного моделирования можно подобрать несколько различных вариантов (форма, наклон зубов), скорректировать и обсудить их с пациентом. Что качественно улучшает процесс лечения и способствует получению оптимальных результатов.
          </p>
          <p>
            Многие стоматологические клиники и лаборатории уже применяют <a href="https://fordent.ru/products/cad-cam-sistemy/" target="_blank" rel="noopener">CAD/CAM системы</a>. Компьютерные технологии в значительной степени превосходят по возможностям традиционных способов изготовления стоматологических конструкций.
          </p>
          <p>
            Быстрота и точность диагностирования позволяют врачам-стоматологам увеличить качество лечения. Цифровые виниры, коронки и вкладки - получаются максимально быстро, точно и красиво.
          </p>
          <p>
            И с каждым годом появляется большое количество нового оборудования и новые программы, в т.ч. cad cam системы в стоматологии. Они эффективно помогают врачам планировать и лечить пациентов, а также повышать рентабельность клиники.
          </p>
          <br><br>
        </div>
          <a-carousel autoplay arrows effect="fade">
            <template #prevArrow>
              <div class="custom-slick-arrow" style="left: 10px; z-index: 1">
                <left-circle-outlined />
              </div>
            </template>
            <template #nextArrow>
              <div class="custom-slick-arrow" style="right: 10px">
                <right-circle-outlined />
              </div>
            </template>
            <div><img class='ii' alt="" src="../assets/cif1.jpg" /></div>
            <div><img class='ii' alt="" src="../assets/cif2.jpg" /></div>
            <div><img class='ii' alt="" src="../assets/cif3.jpg" /></div>
            <div><img class='ii' alt="" src="../assets/cif4.jpg" /></div>
            <div><img class='ii' alt="" src="../assets/cif5.jpg" /></div>
            <div><img class='ii' alt="" src="../assets/cif6.jpg" /></div>
            <div><img class='ii' alt="" src="../assets/cif7.jpg" /></div>
            <div><img class='ii' alt="" src="../assets/clin12.jpg" /></div>
          </a-carousel>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import { Carousel } from 'ant-design-vue';
import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons-vue';
import Foot from '@/components/Foot.vue'

export default {
  name: 'TherapyView',
  components: {
    Head,
    Foot,
    ACarousel: Carousel,
    LeftCircleOutlined, 
    RightCircleOutlined,
  }
}
</script>

<style scoped>

.wrap {
  max-width: 90%;
  margin: 60px auto;
  min-height: 500px;
}

.cont {
  margin: 60px auto;
  margin-bottom: 140px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(520px, 1fr));
}

p {
  width: 95%;
}

.ii {
  width: 100%;
  height: 450px;
  overflow: hidden;
  object-fit: cover;
}

.ant-carousel :deep(.slick-slide) {
  text-align: center;
  height: 450px;
  line-height: 160px;
  overflow: hidden;
}

.ant-carousel :deep(.slick-slide h3) {
  color: #fff;
}

.ant-carousel :deep(.slick-arrow.custom-slick-arrow) {
  width: 35px;
  height: 25px;
  font-size: 35px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
  z-index: 1;
}

.ant-carousel :deep(.custom-slick-arrow:before) {
  display: none;
}

.ant-carousel :deep(.custom-slick-arrow:hover) {
  opacity: 0.5;
}

@media (max-width: 790px) {

.cont {
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}

}

</style>

